var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1994 3.92562C14.682 4.78208 15.8675 6.07116 16.597 7.62018C17.3266 9.16919 17.5653 10.9042 17.2813 12.5926C16.9973 14.2811 16.204 15.8425 15.0078 17.0676C13.8117 18.2927 12.2697 19.123 10.5885 19.4472C8.90724 19.7715 7.16707 19.5742 5.60108 18.8819C4.03508 18.1895 2.71806 17.0352 1.82645 15.5734C0.934833 14.1117 0.511206 12.4124 0.61232 10.7032C0.713434 8.99395 1.33446 7.35644 2.3922 6.01002C2.6346 5.70162 3.1002 5.74842 3.3438 6.05682C3.6782 6.48082 4.0554 6.86242 4.4754 7.20162C4.8738 7.52442 5.4186 7.14282 5.403 6.63042L5.3994 6.40002C5.3994 5.29722 5.6466 4.25322 6.0894 3.31962C6.73014 1.97144 7.77215 0.854404 9.0726 0.121619C9.369 -0.0463806 9.7326 0.102419 9.885 0.407219C10.6194 1.88066 11.7724 3.10458 13.1994 3.92562ZM13.7994 12.4C13.7994 13.6731 13.2937 14.894 12.3935 15.7941C11.4933 16.6943 10.2724 17.2 8.9994 17.2C6.7038 17.2 4.7754 15.5224 4.3074 13.3816C4.1958 12.8668 4.8354 12.61 5.2842 12.886C5.86881 13.2465 6.52396 13.4773 7.2054 13.5628C7.569 13.6084 7.8426 13.2748 7.8174 12.91C7.68607 11.0937 8.25018 9.29546 9.3954 7.87962C9.45639 7.80408 9.53661 7.74638 9.62763 7.71259C9.71865 7.6788 9.81709 7.67017 9.9126 7.68762C11.0068 7.89967 11.9931 8.4859 12.7023 9.34575C13.4115 10.2056 13.7994 11.2854 13.7994 12.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.c759769538f6cae793d4c9f9ef830aaf.svg";
export { ForwardRef as ReactComponent };